import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SanitizedLabel from 'ContentComponents/components/cmv2/SanitizedLabel';
import HelpTooltip from 'ContentComponents/components/cmv2/HelpTooltip';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LABEL_POSITIONS = {
  LEFT: 'left',
  RIGHT: 'right'
};
class BooleanField extends Component {
  constructor(...args) {
    super(...args);
    this.onChange = e => {
      const {
        onFieldChange
      } = this.props;
      onFieldChange(e.target.checked);
    };
  }
  renderLabel() {
    const {
      _label: label,
      helpText,
      labelPosition
    } = this.props;
    if (!label) return null;
    const marginInlineStart = labelPosition === LABEL_POSITIONS.RIGHT ? '500' : undefined;
    const marginInlineEnd = labelPosition === LABEL_POSITIONS.LEFT && !helpText ? '200' : undefined;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(FormLabel, {
        marginInlineStart: marginInlineStart,
        marginInlineEnd: marginInlineEnd,
        paddingInlineEnd: "200",
        children: /*#__PURE__*/_jsx(SanitizedLabel, {
          label: label
        })
      }), helpText && /*#__PURE__*/_jsx(View, {
        paddingInlineEnd: "200",
        paddingBlockStart: "100",
        as: "span",
        children: /*#__PURE__*/_jsx(HelpTooltip, {
          title: helpText
        })
      })]
    });
  }
  render() {
    const {
      _isReadOnly: isReadOnly,
      fieldKey,
      labelPosition,
      readOnly,
      tooltipText,
      value
    } = this.props;
    const checked = typeof value === 'string' ? value === 'true' : value;
    return /*#__PURE__*/_jsxs("div", {
      children: [labelPosition === LABEL_POSITIONS.LEFT && this.renderLabel(), /*#__PURE__*/_jsx(Tooltip, {
        disabled: !tooltipText,
        placement: "right",
        title: tooltipText,
        children: /*#__PURE__*/_jsx(Toggle, {
          "data-selenium": fieldKey && fieldKey.join('.'),
          checked: checked,
          disabled: isReadOnly,
          onChange: this.onChange,
          readOnly: readOnly,
          size: "extra-small"
        })
      }), labelPosition === LABEL_POSITIONS.RIGHT && this.renderLabel()]
    });
  }
}
BooleanField.propTypes = {
  _isReadOnly: PropTypes.bool,
  _label: PropTypes.string,
  fieldKey: PropTypes.array.isRequired,
  helpText: PropTypes.node,
  labelPosition: PropTypes.node,
  onFieldChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  tooltipText: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};
BooleanField.defaultProps = {
  labelPosition: LABEL_POSITIONS.LEFT
};
export default BooleanField;